'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _reactBootstrap = require('react-bootstrap');

var _JsonSchema = require('../JsonSchema');

var _JsonSchema2 = _interopRequireDefault(_JsonSchema);

var _Panel = require('../Panel');

var _Panel2 = _interopRequireDefault(_Panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Component to render the given swagger spec's Definitions Object
 * (https://github.com/OAI/OpenAPI-Specification/blob/master/versions/2.0.md#definitionsObject)
 */
var Definitions = function (_React$Component) {
	_inherits(Definitions, _React$Component);

	function Definitions(props) {
		_classCallCheck(this, Definitions);

		var _this = _possibleConstructorReturn(this, (Definitions.__proto__ || Object.getPrototypeOf(Definitions)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(Definitions, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    doc = _props.doc,
			    levels = _props.levels,
			    expanded = _props.expanded;

			var heading = this.props.heading || this.intl.formatMsg('Definitions');

			return _react2.default.createElement(
				'div',
				{ className: 'definitions' },
				doc.definitions && _react2.default.createElement(
					_reactBootstrap.Accordion,
					null,
					_react2.default.createElement(
						_Panel2.default,
						{
							independent: true,
							eventKey: 'definitions',
							hasIcon: true,
							defaultExpanded: expanded,
							bsStyle: 'default',
							header: heading,
							animate: false,
							borders: false
						},
						Object.keys(doc.definitions).map(function (def) {
							return _react2.default.createElement(
								_reactBootstrap.Accordion,
								{ key: def },
								_react2.default.createElement(
									_Panel2.default,
									{
										independent: true,
										hasIcon: true,
										defaultExpanded: false,
										bsStyle: 'default',
										bsSize: 'small',
										header: def,
										animate: false,
										borders: false
									},
									_react2.default.createElement(_JsonSchema2.default, {
										schema: doc.definitions[def],
										key: def,
										levels: levels,
										id: '/definitions/' + def
									})
								)
							);
						})
					)
				)
			);
		}
	}]);

	return Definitions;
}(_react2.default.Component);

Definitions.propTypes = {
	/**
  * A valid swagger 2.0 document
  */
	doc: _propTypes2.default.object.isRequired,

	/**
  * upto how many levels the rendered tree should expand. Default is 1.
  */
	levels: _propTypes2.default.number,

	/**
  * Optional Heading. Default is 'Definitions'
  */
	heading: _propTypes2.default.string,

	/**
  * Expands on default
  */
	expanded: _propTypes2.default.bool
};

Definitions.defaultProps = {
	levels: 1,
	expanded: true
};

var _default = (0, _reactIntl.injectIntl)(Definitions);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(Definitions, 'Definitions', 'src/components/SwaggerUI/Definitions.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/Definitions.jsx');
}();

;